<template>
	<div class="schedule-component">
		<div class="mb-4">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<li class="breadcrumb-item">
						<a :href=route_back>Расписание</a>
					</li>
					<li class="breadcrumb-item active" aria-current="page">Редактировать расписание обновления ПО</li>
				</ol>
			</nav>
		</div>

		<div class="title-block">
			<div class="mb-2">
				<label class="page-label">Редактировать расписание обновления ПО</label>
			</div>
		</div>

		<div class="schedule-component__select mb-4">
			<div class="form-label">Клиент</div>
			<v-select class="no-searchable"
				v-model="client"
				:options="clients"
				:deselectFromDropdown="false"
				:clearable="false"
				:searchable="false">
			</v-select>
		</div>

		<div class="schedule-component__select mb-4">
			<div class="form-label">Бренд</div>
			<v-select class="no-searchable"
				v-model="brand"
				:options="brands"
				:deselectFromDropdown="false"
				:clearable="false"
				:searchable="false">
			</v-select>
		</div>

		<div class="schedule-component__select mb-4">
			<div class="form-label">Тип устройства</div>
			<v-select class="no-searchable"
				v-model="deviceType"
				:options="deviceTypes"
				:deselectFromDropdown="false"
				:clearable="false"
				:searchable="false">
			</v-select>
		</div>

		<div style="max-width: 510px">
			<div class="tabs">
				<div class="tabs__log-ctrls">
					<button @click="setSelectedTabId"
						:class="{'selected': selectedTabId === 'deviceList'}"
						id="deviceList"
						class="reset-btn tabs__log-ctrl">
						Список устройств
					</button>
					<button @click="setSelectedTabId"
						:class="{'selected': selectedTabId === 'deviceGroups'}"
						id="deviceGroups"
						class="reset-btn tabs__log-ctrl">
						Групппы устройств
					</button>
					<button @click="setSelectedTabId"
						:class="{'selected': selectedTabId === 'pharmList'}"
						id="pharmList"
						class="reset-btn tabs__log-ctrl">
						Список аптек
					</button>
					<button @click="setSelectedTabId"
						:class="{'selected': selectedTabId === 'regions'}"
						id="regions"
						class="reset-btn tabs__log-ctrl">
						Регионы
					</button>
				</div>
			</div>

			<div v-if="selectedTabId === 'deviceList'" class="search-control mb-2">
				<input @keyup.enter="onSearch()" type="text" v-model="search" class="search-control__input form-control" placeholder="Номер аптеки / адрес / ключ лицензии">
				<button @click="onSearch()" class="search-control__input-btn reset-btn">
					<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z" fill="currentColor"></path>
					</svg>
				</button>
			</div>

			<div v-if="selectedTabId === 'deviceGroups'" class="search-control mb-2">
				<input @keyup.enter="onSearch()" type="text" v-model="search" class="search-control__input form-control" placeholder="Введите название группы">
				<button @click="onSearch()" class="search-control__input-btn reset-btn">
					<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z" fill="currentColor"></path>
					</svg>
				</button>
			</div>

			<div v-if="selectedTabId === 'pharmList'" class="search-control mb-2">
				<input @keyup.enter="onSearch()" type="text" v-model="search" class="search-control__input form-control" placeholder="Введите номера аптек через пробел (77-008 77-150...)">
				<button @click="onSearch()" class="search-control__input-btn reset-btn">
					<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z" fill="currentColor"></path>
					</svg>
				</button>
			</div>

			<div v-if="selectedTabId === 'regions'" class="search-control mb-2">
				<input @keyup.enter="onSearch()" type="text" v-model="search" class="search-control__input form-control" placeholder="Введите номера региона">
				<button @click="onSearch()" class="search-control__input-btn reset-btn">
					<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z" fill="currentColor"></path>
					</svg>
				</button>
			</div>
		</div>

		<div class="schedule-component__select mb-5">
			<label for="exampleFormControlInput4" class="form-label">Интервал времени</label>
			<div class="interval-input">
				<span>C</span>
				<input type="time" class="form-control" id="exampleFormControlInput4">
				<span>По</span>
				<input type="time" class="form-control" id="exampleFormControlInput4">
			</div>
		</div>

		<div class="schedule-component__btns">
			<button type="button" class="btn btn-lg btn-primary" @click="closeModal">
				Сохранить
			</button>
			<button type="button" class="btn btn-lg btn-outline-dark" @click="this.showModal = false">
				Отменить
			</button>
		</div>

	</div>
</template>

<script>
export default {
    name: 'EditSoftwareUpdateScheduleComponent',

	data() {
		return {
			client: 'Выберите клиента',
			clients: ['Клиент 1', 'Клиент 2', 'Клиент 3'],

			brand: 'Выберите бренд',
			brands: ['бренд 1', 'бренд 2', 'бренд 3'],

			deviceType: 'Выберите тип устройства',
			deviceTypes: ['Тип устройства 1', 'Тип устройства 2', 'Тип устройства 3'],

			selectedTabId: 'deviceList',

			startTime: '',
			endTime: '',

			selectedItems: [
				{id: 1, address: '77-505, г. Москва, ул. Воронцовская, д. 48.', device_type: 'Киоск ЭО', license_key: 'e3571sq152586q'},
				{id: 2, address: '77-351, г. Москва, ул. Профсоюзная, д. 18.', device_type: 'ТВ', license_key: 'e3571sq152586q'},
				{id: 3, address: '77-505, г. Москва, ул. Воронцовская, д. 48.', device_type: 'Киоск ЭО', license_key: 'e3571sq152586q'},
				{id: 4, address: '77-505, г. Москва, ул. Воронцовская, д. 48.', device_type: 'Киоск ЭО', license_key: 'e3571sq152586q'},
				{id: 5, address: '77-505, г. Москва, ул. Воронцовская, д. 48.', device_type: 'Киоск ЭО', license_key: 'e3571sq152586q'},
				{id: 6, address: '77-505, г. Москва, ул. Воронцовская, д. 48.', device_type: 'Киоск ЭО', license_key: 'e3571sq152586q'},
				{id: 7, address: '77-505, г. Москва, ул. Воронцовская, д. 48.', device_type: 'Киоск ЭО', license_key: 'e3571sq152586q'},
				{id: 8, address: '77-505, г. Москва, ул. Воронцовская, д. 48.', device_type: 'Киоск ЭО', license_key: 'e3571sq152586q'},
				{id: 9, address: '77-505, г. Москва, ул. Воронцовская, д. 48.', device_type: 'Киоск ЭО', license_key: 'e3571sq152586q'},
				{id: 10, address: '77-505, г. Москва, ул. Воронцовская, д. 48.', device_type: 'Киоск ЭО', license_key: 'e3571sq152586q'},
				{id: 11, address: '77-505, г. Москва, ул. Воронцовская, д. 48.', device_type: 'Киоск ЭО', license_key: 'e3571sq152586q'},
			],
		}
	},

	methods: {
		setSelectedTabId(e) {
			this.selectedTabId = e.target.id;
		},
		removeItem (index) {
            this.selectedItems.splice(index, 1);
        },
	}
}
</script>

<style scoped lang="scss">
	.title-block {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
        &__btns {
            margin-left: auto;
            display: flex;
            gap: 6px;
        }
	}
	.page-label {
		font-size: 18px;
		font-weight: 600;
	}
	.schedule-component {
		&__select {
			max-width: 400px;
		}
		&__btns {
			display: flex;
			gap: 16px;
			button {
				width: 214px;
			}
		}
		&__selected-items {
			display: flex;
			flex-direction: column;
			max-height: 170px;
			max-width: 710px;
			overflow-y: auto;
			gap: 10px;
			.selected-item {
				display: flex;
				align-items: center;
				justify-content: center;
				&__text {
					font-size: 16px;
					font-weight: 400;
					color: #0678F4;
				}
				&__icon {
					margin-left: auto;
					margin-right: 6px;
					min-height: 20px;
					min-width: 20px;
					cursor: pointer;
					transition: 0.2s;
					&:hover {
						color: red;
						transition: 0.2s;
					}
				}
			}
		}
	}
	.tabs {
		&__log-ctls {
			gap: 10px !important;
		}
	}
	.interval-input {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 6px;
	}
</style>
